import { api } from "./api";
import { logger } from "./logger";

export const fetchDeployStatus = async () => {
  logger.info("Buscando status de deploy (beta/prod)...");
  return api.get("/deploy-control/status");
};

export const promoteBetaToProd = async () => {
  logger.info("Promovendo beta -> produção...");
  return api.post("/deploy-control/promote");
};

export const rollbackProduction = async () => {
  logger.info("Solicitando rollback para versão anterior/estável...");
  return api.post("/deploy-control/rollback");
};
